import { render, staticRenderFns } from "./v-tableColumn.vue?vue&type=template&id=a5b6f4ea&scoped=true&"
import script from "./v-tableColumn.vue?vue&type=script&lang=js&"
export * from "./v-tableColumn.vue?vue&type=script&lang=js&"
import style0 from "./v-tableColumn.vue?vue&type=style&index=0&id=a5b6f4ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b6f4ea",
  null
  
)

export default component.exports